export default "__VITE_ASSET__CiG84lLk__"